module.exports = __webpack_public_path__ + "static/media/gitlablogo.d5595f2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/gitlablogo.svg
// module id = 837
// module chunks = 0